import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LocalizedText from '@LocalizedText';

import FileInput from '@components/buttons/file-input-btn/FileInput';
import './DropZone.scss';

const DropZone = ({ titleLocKey, fileBtnLocKey, handleFileSelect, resetSelectedFile, supportedTypes = '', dropZoneTitle }) => {
  const [isDragProcess, setIsDragProcess] = useState(false);
  const [isDropped, setIsDropped] = useState(false);

  const handleFileDrop = ({ dataTransfer }) => {
    setIsDropped(true);
    setIsDragProcess(false);
    const [file] = dataTransfer.files;
    file && handleFileSelect(file);
  };

  return (
    <div
      id="upload-drop-zone"
      onDrop={handleFileDrop}
      onDragEnter={() => {
        resetSelectedFile();
        setIsDropped(false);
      }}
      onDragOver={() => setIsDragProcess(true)}
      onDragLeave={() => setIsDragProcess(false)}
      className={classnames({ 'drag-over': isDragProcess, dropped: isDropped })}
      aria-label={dropZoneTitle}
    >
      <div className="drop-zone-title">
        <LocalizedText id={titleLocKey} />
      </div>
      <LocalizedText id="qau-upload-or-text" />
      <FileInput
        handleFileSelect={file => {
          resetSelectedFile();
          handleFileSelect(file);
        }}
        locKey={fileBtnLocKey}
        accept={supportedTypes}
      />
    </div>
  );
};

DropZone.propTypes = {
  titleLocKey: PropTypes.string,
  fileBtnLocKey: PropTypes.string,
  supportedTypes: PropTypes.string,
  handleFileSelect: PropTypes.func.isRequired,
  resetSelectedFile: PropTypes.func.isRequired,
  dropZoneTitle: PropTypes.string,
};

export default DropZone;
